import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { VtsSortBy } from "@/models/VtsLogSearch"
import { useLoggedInUser } from "@/stores/coreDataStore"
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { canEditVtsLog } from "../permissions"
import { useVtsLogStore } from "../store"
import SortableVtsHeading from "./SortableVtsHeading"
import "./tableStyles.scss"

const VtsTable: ReactiveComponent = () => {
	const loggedInUser = useLoggedInUser()
	const store = useVtsLogStore()

	return () => (
		<table class="grid-table vts-logs-table">
			<thead>
				<tr>
					<SortableVtsHeading sort={VtsSortBy.LogTime} text="Log Time" align="left" />
					<SortableVtsHeading sort={VtsSortBy.EditedAt} text="Edited At" align="left" />
					<SortableVtsHeading sort={VtsSortBy.From} text="From" align="left" />
					<SortableVtsHeading sort={VtsSortBy.To} text="To" align="left" />
					<th>Remarks</th>
					<th />
				</tr>
			</thead>
			<tbody>
				{store.getResults().logs.map((log) => (
					<tr key={log.id}>
						<td>{log.logTime.toUTCDateTimeString()}</td>
						<td>{log.editedAt.toUTCDateTimeString()}</td>
						<td>{log.fromOther !== "" ? log.fromOther : log.from.name}</td>
						<td>{log.toOther !== "" ? log.toOther : log.to.name}</td>
						<td>{log.remarks}</td>
						<td>
							<BootstrapButton
								color="primary"
								title={canEditVtsLog(log, loggedInUser) ? "Edit VTS Log" : "View VTS Log"}
								onClick={() => store.openLog(log.id)}
							>
								<Icon icon={canEditVtsLog(log, loggedInUser) ? faEdit : faEye} />
							</BootstrapButton>
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}

export default defineComponent(VtsTable)
